<template>
    <b-dropdown v-bind="$attrs">
        <template #button-content>
            <b-icon icon="gear" /> {{ text }}
        </template>
        <slot></slot>
    </b-dropdown>
</template>

<script>
export default {
    props: {
        text: {
            type: String
        }
    }
}
</script>